import React from 'react';

export function transformDateToDetails(dateString) {
  let newData = new Date(dateString);
  return (
    ('0' + newData.getDate()).slice(-2) +
    '/' +
    ('0' + (newData.getMonth() + 1)).slice(-2) +
    '/' +
    newData.getFullYear()
  );
}

export function transformDateToParam(dateString) {
  let newData = new Date(dateString);
  return (
    newData.getFullYear() +
    ('0' + (newData.getMonth() + 1)).slice(-2) +
    ('0' + newData.getDate()).slice(-2)
  );
}

export function transformDateToRecur(dayNumber) {
  switch (dayNumber) {
    case 0:
      return 'SU';
    case 1:
      return 'MO';
    case 2:
      return 'TU';
    case 3:
      return 'WE';
    case 4:
      return 'TH';
    case 5:
      return 'FR';
    case 6:
      return 'SA';
  }
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function buildCalendarUrl(currentState) {
  const baseUrl = 'https://calendar.google.com/calendar/r/eventedit?';
  const endDate = transformDateToDetails(currentState.endDate);
  const countDate = transformDateToDetails(currentState.countDate);
  const startDate = transformDateToDetails(currentState.startDate);
  const releaseDate = transformDateToDetails(currentState.releaseDate);
  const startDateParam = transformDateToParam(currentState.countDate);

  const endDateParam = transformDateToParam(currentState.endDate) + 'T093000';

  const reccurDate = transformDateToRecur(
    new Date(currentState.endDate).getDay()
  );
  const reccurParam = `RRULE:FREQ=WEEKLY;BYDAY=${reccurDate};INTERVAL=1;UNTIL=${endDateParam}`;
  let action = '';
  currentState.actionSelect.forEach(x => {
    if (currentState.action == x.id) {
      action = x.action;
    }
  });
  let court = '';
  currentState.courtSelect.forEach(x => {
    if (currentState.court == x.id) {
      court = x.court;
    }
  });
  const title = `${endDate.toString().slice(0, 5)} : ${toTitleCase(
    currentState.claimant
  )} : ${toTitleCase(currentState.claimed)} : ${action}`;
  const details = `Reclamante(s): ${currentState.claimant}%3Cbr%3E
  Reclamados(as): ${currentState.claimed}%3Cbr%3E
  Processo: ${currentState.processNumber}%3Cbr%3E
  Prosseguimento Necessário ${action}%3Cbr%3E
  Vara: ${court}%3Cbr%3E
  Data de disponibilização: ${releaseDate}%3Cbr%3E
  Data de publicação: ${startDate}%3Cbr%3E
  Data de início de contagem: ${countDate}%3Cbr%3E
  Data de fim: ${endDate}%3Cbr%3E
  Dias úteis: ${currentState.workDays}%3Cbr%3E
  Observações: ${currentState.observation}%3Cbr%3E`;

  return `${baseUrl}text=${title}&dates=${startDateParam}T090000/${startDateParam}T093000&ctz=America/Sao_Paulo&details=${details}&location=${currentState.processNumber}&recur=${reccurParam}`;
}

export function convertAction(action, actionSelect) {
  let actionSelected;
  actionSelect.map((a, i) => {
    if (a.id === action) {
      actionSelected = a.action;
    }
  });
  return (
    <>
      {' '}
      {
        <strong>
          {actionSelected}
          <br />
        </strong>
      }
    </>
  );
}

export function modalText(item, text) {
  if (typeof item.getMonth === 'function') {
    return (
      <>
        {' '}
        {
          <strong>
            {new Date(item).toLocaleDateString() + ' ' + text}
            <br />
          </strong>
        }
      </>
    );
  }
  return (
    <>
      {' '}
      {
        <strong>
          {item + ' ' + text}
          <br />
        </strong>
      }
    </>
  );
}
